// ─────────────────────────────────────────────────────────────────────────────
// Tenant User Tour Steps
//
// For regular users (r7) — more limited than admin tour
// IDs match PlatformLayout RenderMenuItem generated IDs
// skipIfNotFound: silently skip if section not available for this user
// ─────────────────────────────────────────────────────────────────────────────

const P = 'right-start';

export const getTenantUserSteps = (features = {}) => {
  const steps = [];

  // ── Step 1: Welcome (centered hero modal) ────────────────────────────────
  steps.push({
    target: null,
    isWelcome: true,
    title: 'Welcome to Your Workspace!',
    content: "Let's take a quick tour to help you find everything you need. It only takes a minute — skip any time or restart from your profile menu.",
    placement: 'center',
    disableBeacon: true,
  });

  // ── Step 2: AIDAS Apps (apps assigned by admin) ──────────────────────────
  // Section only renders when aidasAppsMenu.length > 0
  if (features?.assigned_apps !== false) {
    steps.push({
      target: '#sidebar-aidas-apps',
      skipIfNotFound: true,
      title: 'Your Apps',
      content: 'Access the curated applications and dashboards your administrator has assigned specifically to you and your team.',
      placement: P,
    });
  }

  // ── Step 3: Published Content ────────────────────────────────────────────
  // Section only renders when publishedAppsMenu.length > 0
  steps.push({
    target: '#sidebar-published-apps',
    skipIfNotFound: true,
    title: 'Published Content',
    content: 'Dashboards and workflows shared across your entire organization appear here — ready to view and interact with.',
    placement: P,
  });

  // ── Step 4: Agentic Insights ───────────────────────────────────────────────────
  if (features?.ai_insight !== false) {
    steps.push({
      target: '#sidebar-ai-insight',
      title: 'Agentic Insights',
      content: 'Have a question about your data? Ask it in plain English and get instant AI-generated insights, charts, and summaries.',
      placement: P,
    });
  }

  // ── Step 5: Knowledge Base ───────────────────────────────────────────────
  // item.id = 'semantic-kb' → id="sidebar-semantic-kb"
  if (features?.semantic_kb !== false) {
    steps.push({
      target: '#sidebar-semantic-kb',
      title: 'Knowledge Base',
      content: 'View the business context and terminology your team has configured to make Agentic Insights more accurate and relevant.',
      placement: P,
    });
  }

  // ── Step 6: Task Center ──────────────────────────────────────────────────
  steps.push({
    target: '#sidebar-tasks',
    skipIfNotFound: true,
    title: 'Task Center',
    content: 'View and act on workflow tasks or approvals that have been assigned specifically to you.',
    placement: P,
  });

  // ── Step 7: Support ──────────────────────────────────────────────────────
  steps.push({
    target: '#sidebar-support',
    title: 'Support',
    content: "Need help? Raise a support ticket and get assistance from your organization's admin team.",
    placement: P,
  });

  // ── Step 8: Profile ──────────────────────────────────────────────────────
  steps.push({
    target: '#user-profile-menu',
    title: 'Your Profile',
    content: 'Update your personal information, change your password, manage security settings, and restart this tour any time.',
    placement: 'bottom-end',
  });

  return steps;
};
